<app-barra-crud [state]="state" (salvando)="salvar()" (voltando)="busca()" (inserindo)="novo()" (editando)="editar()"
  (excluindo)="excluir()" (cancelando)="cancelar()" [formValido]="f.valid">
</app-barra-crud>
<div class="conteudo cadastro">
  <form role="form" #f="ngForm" novalidate>
    <nav class="topo-abas">
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a translate id="dados-principais-tab" href="#dados-principais" aria-controls="dados-principais"
          aria-selected="true" class="nav-item nav-link active" data-toggle="tab" role="tab">
          {{'parametros.despesa.cadastro.dadosPrincipais.abaDadosPrincipais'}}
        </a>
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div id="dados-principais" aria-labelledby="dados-principais-tab" class="tab-pane fade show active"
        role="tabpanel">
        <header translate class="titulo">{{'parametros.despesa.cadastro.dadosPrincipais.abaDadosPrincipais'}}</header>
        <div class="container-fluid">
          <div class="row">
            <div class="col col-lg-12">
              <small translate class="text-info">{{'parametros.despesa.cadastro.CampoObrigatorio'}}</small>
              <hr />
            </div>
          </div>
          <div class="row" *ngIf="!carregando">
            <div class="div-check">
              <input id="check" type="checkbox" [checked]="todos" (change)="todosDealers()" />
              <label translate class="label-check"
                for="check">{{'parametros.despesa.cadastro.dadosPrincipais.todosOsDealers'}}</label>
            </div>
          </div>
          <div class="row">
            <app-text-box [state]="state" class="col-lg-2"
              label="{{'parametros.despesa.cadastro.dadosPrincipais.idDespesa' | translate}}" name="idDespesa"
              [(ngModel)]="model.id"
              placeholder="{{'parametros.despesa.cadastro.dadosPrincipais.idDespesaPlaceHolder' | translate}}"
              [ativo]="false"></app-text-box>
          </div>
          <div class="row">
            <app-dropdown-list-api [state]="state" class="col-md-4 col-lg-5"
              label="{{'parametros.despesa.cadastro.dadosPrincipais.dealer' | translate}}" name="dealer"
              [(ngModel)]="model.id_dealer" obrigatorio="true" required filtro="dealer">
            </app-dropdown-list-api>
            <app-dropdown-list-api [state]="state" class="col-md-4 col-lg-5"
              label="{{'parametros.despesa.cadastro.dadosPrincipais.tipoDespesa' | translate}}" name="tipo"
              [(ngModel)]="model.id_categoria_despesa" required [itens]="itensTipo" filtro="categoria_despesa">
            </app-dropdown-list-api>
          </div>
          <div class="row">
            <app-text-box [state]="state" class="col-lg-5"
              label="{{'parametros.despesa.cadastro.dadosPrincipais.ano' | translate}}" name="ano"
              [(ngModel)]="model.ano" obrigatorio="true" required
              placeholder="{{'parametros.despesa.cadastro.dadosPrincipais.anoPlaceHolder' | translate}}"></app-text-box>
            <app-dropdown-list [state]="state" class="col-md-4 col-lg-5"
              label="{{'parametros.despesa.cadastro.dadosPrincipais.mes' | translate}}" name="tipoDealer"
              [(ngModel)]="model.mes" required [itens]="meses"></app-dropdown-list>
          </div>
          <div class="row">
            <app-text-box [state]="state" class="col-lg-10"
              label="{{'parametros.despesa.cadastro.dadosPrincipais.valor' | translate}}" name="valor_previsao"
              appFormatCurrency [(ngModel)]="model.valor" obrigatorio="true" required placeholder="R$..." #inputValor
              (keyup)="model.valor=$event.target.value">
            </app-text-box>
          </div>
          <hr />
          <div class="jumbotron">
            <div class="row">
              <div class="col-10">
                <legend translate>{{'parametros.despesa.cadastro.dadosPrincipais.legenda1'}}</legend>
                <legend translate>{{'parametros.despesa.cadastro.dadosPrincipais.legenda2'}}</legend>
                <legend translate>{{'parametros.despesa.cadastro.dadosPrincipais.legenda3'}}</legend>
                <legend translate>{{'parametros.despesa.cadastro.dadosPrincipais.legenda4'}}</legend>
                <legend translate>{{'parametros.despesa.cadastro.dadosPrincipais.legenda5'}}</legend>
              </div>
              <div class="col-2">
                <div class="float-right mr-4">
                  <a class="btn download" href="assets/modelos/modelo-despesas.xlsx">
                    <i class="fas fa-file-download"></i>
                  </a>
                  {{'parametros.despesa.cadastro.dadosPrincipais.modelo' | translate}}
                </div>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="state == 1">
            <div class="col col-lg-12">
              <p translate class="text-info">
                {{'parametros.despesa.cadastro.dadosPrincipais.adicionarArquivoXlsCadastro'}}</p>
              <p-fileUpload mode="advanced" fileLimit="1" name="myfile[]" customUpload="true" accept=".xlsx"
                (uploadHandler)="uploader($event)"></p-fileUpload>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>